var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.setTitle(),
        visible: _vm.showDialog,
        width: "750px",
        "before-close": _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          ref: "user",
          staticClass: "demo-ruleForm",
          attrs: {
            model: _vm.formValidate,
            rules: _vm.rules,
            "label-width": "120px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("cpmc"), prop: "name" } },
            [
              _c(
                "span",
                { attrs: { slot: "label" }, slot: "label" },
                [
                  _c(
                    "el-tooltip",
                    {
                      attrs: {
                        content: _vm.$t("qzstxdqxtszyydcpmc"),
                        placement: "top",
                      },
                    },
                    [_c("i", { staticClass: "el-icon-question" })]
                  ),
                  _vm._v("\n        " + _vm._s(_vm.$t("cpmc")) + "\n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex-start lang-block" },
                _vm._l(_vm.lang_values, function (item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "lang-item flex-start" },
                    [
                      _c("p", { staticClass: "lanbels" }, [
                        _vm._v(_vm._s(_vm.languarList[index].value)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "lanbels-content" },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: _vm.formType == "detail",
                              placeholder: _vm.$t("qsrcpmc"),
                            },
                            model: {
                              value: item.value,
                              callback: function ($$v) {
                                _vm.$set(item, "value", $$v)
                              },
                              expression: "item.value",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("zdtzje"), prop: "min_price" } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  disabled: _vm.formType == "detail",
                  placeholder: _vm.$t("qsrzdtzje"),
                },
                model: {
                  value: _vm.formValidate.min_price,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "min_price", _vm._n($$v))
                  },
                  expression: "formValidate.min_price",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("zgtzje"), prop: "top_price" } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  disabled: _vm.formType == "detail",
                  placeholder: _vm.$t("qsrzgtzje"),
                },
                model: {
                  value: _vm.formValidate.top_price,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "top_price", _vm._n($$v))
                  },
                  expression: "formValidate.top_price",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("lilv"), prop: "rate" } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  disabled: _vm.formType == "detail",
                  placeholder: _vm.$t("qsrlilv"),
                },
                model: {
                  value: _vm.formValidate.rate,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "rate", _vm._n($$v))
                  },
                  expression: "formValidate.rate",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("sdsj"), prop: "day" } },
            [
              _c("el-input", {
                attrs: {
                  type: "number",
                  disabled: _vm.formType == "detail",
                  placeholder: _vm.$t("qsrsdsj"),
                },
                model: {
                  value: _vm.formValidate.day,
                  callback: function ($$v) {
                    _vm.$set(_vm.formValidate, "day", _vm._n($$v))
                  },
                  expression: "formValidate.day",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("sftj"), prop: "is_hot" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: _vm.formType == "detail" },
                  model: {
                    value: _vm.is_hot,
                    callback: function ($$v) {
                      _vm.is_hot = $$v
                    },
                    expression: "is_hot",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(" " + _vm._s(_vm.$t("shi")) + " "),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(" " + _vm._s(_vm.$t("fou")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("jslx"), prop: "mode_type" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: _vm.formType == "detail" },
                  model: {
                    value: _vm.mode_type,
                    callback: function ($$v) {
                      _vm.mode_type = $$v
                    },
                    expression: "mode_type",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(_vm._s(_vm.$t("mrjs"))),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [
                    _vm._v(_vm._s(_vm.$t("dqbx"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("status"), prop: "status" } },
            [
              _c(
                "el-radio-group",
                {
                  attrs: { disabled: _vm.formType == "detail" },
                  model: {
                    value: _vm.status,
                    callback: function ($$v) {
                      _vm.status = $$v
                    },
                    expression: "status",
                  },
                },
                [
                  _c("el-radio", { attrs: { label: 1 } }, [
                    _vm._v(" " + _vm._s(_vm.$t("yjh")) + " "),
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 0 } }, [
                    _vm._v(" " + _vm._s(_vm.$t("bky")) + " "),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.resetForm("user")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("calcelText")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.submitForm("formValidate")
                },
              },
            },
            [_vm._v(_vm._s(_vm.$t("trueText")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }